<template>
  <div class="team-avail">
    <div class="team-avail-inner">
      <div class="">
        <div class="team-avail-head">
          {{
            isOnline
              ? $t('TEAM_AVAILABILITY.ONLINE')
              : $t('TEAM_AVAILABILITY.OFFLINE')
          }}
        </div>
        <div class="team-avail-msg">
          {{ replyWaitMessage }}
        </div>
      </div>
      <div class="team-availability-agents">
        <available-agents v-if="isOnline" :agents="availableAgents" />
      </div>
    </div>
    <button
      class="team-avail-button"
      :style="{ color: 'var(--brand-text-on-white-background)' }"
      @click="startConversation"
    >
      <span class="team-avail-button-text">
        {{
          hasConversation
            ? $t('CONTINUE_CONVERSATION')
            : $t('START_CONVERSATION')
        }}
      </span>
      <fluent-icon icon="arrow-right-new" size="16" view-box="0 0 16 16" />
    </button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getContrastingTextColor } from '@chatwoot/utils';
import nextAvailabilityTime from 'widget/mixins/nextAvailabilityTime';
import AvailableAgents from 'widget/components/AvailableAgents.vue';
import configMixin from 'widget/mixins/configMixin';
import availabilityMixin from 'widget/mixins/availability';
import FluentIcon from 'shared/components/FluentIcon/Index.vue';
import { IFrameHelper } from 'widget/helpers/utils';
import { CHATWOOT_ON_START_CONVERSATION } from '../constants/sdkEvents';

export default {
  name: 'TeamAvailability',
  components: {
    AvailableAgents,
    FluentIcon,
  },
  mixins: [configMixin, nextAvailabilityTime, availabilityMixin],
  props: {
    availableAgents: {
      type: Array,
      default: () => {},
    },
    hasConversation: {
      type: Boolean,
      default: false,
    },
    unreadCount: {
      type: Number,
      default: 0,
    },
  },

  computed: {
    ...mapGetters({
      widgetColor: 'appConfig/getWidgetColor',
    }),
    textColor() {
      return getContrastingTextColor(this.widgetColor);
    },
    isOnline() {
      const { workingHoursEnabled } = this.channelConfig;
      const anyAgentOnline = this.availableAgents.length > 0;

      if (workingHoursEnabled) {
        return this.isInBetweenTheWorkingHours;
      }
      return anyAgentOnline;
    },
  },
  methods: {
    startConversation() {
      this.$emit('start-conversation');
      if (!this.hasConversation) {
        IFrameHelper.sendMessage({
          event: 'onEvent',
          eventIdentifier: CHATWOOT_ON_START_CONVERSATION,
          data: { hasConversation: false },
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.team-avail {
  @apply px-5 py-3 shadow-sm rounded-md bg-neutral;
}
.team-avail-inner {
  @apply flex items-center justify-between;
}
.team-avail-head {
  @apply text-sm font-semibold text-primary;
}
.team-avail-msg {
  @apply text-sm mt-1 text-slate-500;
}
.team-availability-agents {
  @apply -mt-14;
}
.team-avail-button {
  @apply inline-flex text-sm font-semibold rounded-md py-1 mt-2 px-2 -ml-2 leading-6 text-slate-800 justify-between items-center hover:bg-neutral-subtle transition-all ease-in-out duration-200;
}
.team-avail-button-text {
  @apply pr-2 text-sm;
}
</style>
